
































import {defineComponent} from "@vue/composition-api";
import useBuilderStore from "@tool/store/useBuilderStore";
import Alert from "@base/Components/Alert.vue";

export default defineComponent({
    components: {
        Alert
    },
    setup() {
        const {projectBuilderSettings} = useBuilderStore();

        return {
            projectBuilderSettings
        };
    }
});
